import styles from './styles.module.scss'

type ProgressBarProps = {
  progress: number
  theme: 'primary' | 'secondary'
  variant?: 'edge' | 'round'
}

function ProgressBar({
  progress,
  variant = 'round',
  theme = 'primary'
}: ProgressBarProps) {
  const width = `${progress * 100}%`
  return (
    <div
      className={`${styles.progressBar__wrapper} ${
        progress === 0 ? styles.progressBar_initial : ''
      } ${styles[variant]} ${styles[theme]}`}
    >
      <div className={styles.progressBar} style={{ width }} />
    </div>
  )
}

export default ProgressBar
